import { useTranslation } from "react-i18next";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { ResizableWrapper } from "../../shared/components/ResizableWrapper";
import { ChatbotDialogs } from "./Components/ChatbotDialogs";
import { ChatbotMain } from "./Components/ChatbotMain";
import { AddNewBotModal } from "./Components/AppNewBotDialog";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";

export const Chatbot = () => {
  const { selectedObject } = useStorageSelectors("ai_agents_telegram_bots");
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const { t } = useTranslation();

  return (
    <>
      {selectedObject?.value === null ? (
        <NoObjectChosen
          message={t("chatbot.no_object_message")}
          folderName={selectedObject?.friendly_name}
          onClick={() =>
            handleOpenModal("add_new_bot_modal", null, "add_from_folder")
          }
        />
      ) : (
        <ResizableWrapper
          leftBlock={<ChatbotMain />}
          rightBlock={<ChatbotDialogs />}
          isCollapsible={false}
          leftBlockSize={55}
          rightBlockSize={45}
          leftBlockMinSize={30}
        />
      )}
      <AddNewBotModal
        addBotModalType={"add_from_folder"}
        closeModal={handleCloseModal}
      />
    </>
  );
};
